const PREFIX = '@@secondaryMenu/';

export const SECONDARY_MENU_ACTION_TYPES = {
    FETCH_REQUEST: `${PREFIX}FETCH_REQUEST`,
    FETCH_SUCCESS: `${PREFIX}FETCH_SUCCESS`,
    FETCH_FAILURE: `${PREFIX}FETCH_FAILURE`,
};
